import { FC, useCallback } from 'react'
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { useStore } from 'effector-react'
import { $mainTable } from '../../Api/PaidService/search'
import {
  $paidServiceFastFilter,
  addFieldToPaidServiceFastFilter
} from './store/paidServiceFastFilter'
import { MY_PAID_SERVICE_STATUS_OPTIONS } from './consts'

/** Быстрый фильтр "Мои" — повторный клик по активной кнопке снимает фильтр */
export const PaidServiceFastFilter: FC = () => {
  const paidServiceFastFilter = useStore($paidServiceFastFilter)
  const mainTable = useStore($mainTable) as any

  // Активная кнопка: myInWork (1/2), 0 — фильтр "Мои" не задан
  const activeStatus = paidServiceFastFilter?.myInWork || 0

  const handleClick = useCallback(
    (statusId: number) => {
      if (activeStatus === statusId) {
        addFieldToPaidServiceFastFilter({
          myInWork: undefined,
          myInWorkUnread: undefined
        })
        return
      }

      addFieldToPaidServiceFastFilter({
        myInWork: statusId,
        myInWorkUnread: undefined
      })
    },
    [activeStatus]
  )

  return (
    <Stack direction={'row'} spacing={2} alignItems={'center'}>
      <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>
        Мои:
      </Typography>

      <ToggleButtonGroup color="info" value={activeStatus} size="small">
        {MY_PAID_SERVICE_STATUS_OPTIONS.map(({ id, label }) => (
          <ToggleButton
            value={id}
            sx={{ fontSize: '11px', padding: '4px 10px' }}
            onClick={() => handleClick(id)}
            key={id}
          >
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      {!!activeStatus && (
        <Typography sx={{ fontSize: '12px' }} color="text.secondary">
          Найдено: {mainTable?.data?.totalRowCount ?? '...'}
        </Typography>
      )}
    </Stack>
  )
}
